import React from 'react';
import AsyncSection from '../../../../../../../../Components/AsyncSection';
import LeadershipTeamAlignment from './children/LeadershipTeamAlignment';
import StakeholderGroupsAlignment from './children/StakeholderGroupsAlignment';

const AlignmentInsights = (props) => {
    return (
        <>
            <AsyncSection
                api={props.fetchBenchmarkAlignmentScoreApi}
                isEmpty={(data) =>
                    !data ||
                    !data.available ||
                    !data.managersRanked ||
                    data.managersRanked.length === 0 ||
                    !data.teamMembersRanked ||
                    data.teamMembersRanked.length === 0
                }
            >
                <LeadershipTeamAlignment />
            </AsyncSection>

            <AsyncSection api={props.fetchRankDeltaApi}>
                <StakeholderGroupsAlignment />
            </AsyncSection>
        </>
    );
};

export default AlignmentInsights;